<div class="modal-header bg-dark text-white">
    <h5 class="modal-title">
        <i class="fas fa-key fa-fw"></i>
        비밀번호 재설정
    </h5>
    <button type="button" class="close text-white" (click)="clickCancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="fgRequest" (ngSubmit)="onSubmitRequest()">
        <div class="h4 mb-0">
            1.인증키 발급을 위한 정보 입력
        </div>

        <hr>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0 text-right">
                인증방식
            </label>
            <div class="col-md-9 position-relative">
                <select class="form-control form-control-sm w-auto"
                    formControlName="authType">
                    <option [ngValue]="'1'">이메일</option>
                    <option [ngValue]="'2'" disabled>SMS</option>
                </select>
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0 text-right">
                로그인 계정
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm"
                    formControlName="userId"
                    [ngClass]="{'is-invalid':submittedRequest && fReq.userId.errors}">
                <div class="invalid-tooltip" *ngIf="submittedRequest && fReq.userId.errors">
                    <div *ngIf="fReq.userId.errors.required">필수 입력 항목 입니다</div>
                </div>
            </div>
            <!-- <div class="col-md-9 offset-md-3 small mt-1">
                <small class="form-text text-muted">
                    운전종사자자격증 또는 운전자사번 또는 주민번호 뒤 7자리<br>
                    '-' 하이픈을 제외 한 숫자만 입력
                </small>
            </div> -->
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0 text-right">
                인증 받을 연락처
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm"
                    formControlName="authTo"
                    [ngClass]="{'is-invalid':submittedRequest && fReq.authTo.errors}">
                <div class="invalid-tooltip" *ngIf="submittedRequest && fReq.authTo.errors">
                    <div *ngIf="fReq.authTo.errors.required">필수 입력 항목 입니다</div>
                </div>
            </div>
            <div class="col-md-9 offset-md-3 small mt-1">
                <small class="form-text text-muted">
                    이메일 인증방식의 경우 이메일을 입력<br>
                    SMS 인증방식의 경우 '-' 하이픈을 제외 한 숫자만 입력
                </small>
            </div>
        </div>

        <div class="form-group row align-items-center mb-0">
            <div class="col-md-3 mb-0 text-right"></div>
            <div class="col-md-9 position-relative">
                <button type="submit" class="btn btn-sm btn-secondary">
                    인증키 요청
                </button>

                <div class="small text-muted mt-2">
                    ※ 이메일, 휴대폰번호 미등록 시 관리자에게 문의해 주세요. 1833-5697
                </div>

                <div class="text-danger mt-2" [hidden]="!requestFailMessage">
                    <i class="mdi mdi-alert-outline"></i>
                    <span class="ml-1" [innerHtml]="requestFailMessage"></span>
                </div>
            </div>
        </div>
    </form>

    <form [formGroup]="fgCheck"
        (ngSubmit)="onSubmitCheck()"
        [hidden]="isSentAuthKey === false">
        <div class="h4 mb-0 mt-4">
            2.발급 된 인증키 확인
        </div>

        <hr>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0 text-right">
                인증키
            </label>
            <div class="col-md-9 position-relative">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control form-control-sm"
                        formControlName="authKey"
                        [ngClass]="{'is-invalid':submittedCheck && fCheck.authKey.errors}">
                    <div class="invalid-tooltip" *ngIf="submittedCheck && fCheck.authKey.errors">
                        <div *ngIf="fCheck.authKey.errors.required">필수 입력 항목 입니다</div>
                    </div>
                    <div class="input-group-append">
                        <span class="input-group-text">
                            {{getAuthTimeLimit() | date:'mm:ss'}}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group row align-items-center mb-0">
            <div class="col-md-3 mb-0 text-right"></div>
            <div class="col-md-9 position-relative">
                <button type="submit" class="btn btn-sm btn-secondary">
                    인증키 확인
                </button>

                <div class="text-danger mt-2" [hidden]="!checkFailMessage">
                    <i class="mdi mdi-alert-outline"></i>
                    <span class="ml-1" [innerHtml]="checkFailMessage"></span>
                </div>
            </div>
        </div>
    </form>

    <form [formGroup]="fgNewPw"
        (ngSubmit)="onSubmitNewPw()"
        [hidden]="isAuthKeyOk === false">
        <div class="h4 mb-0 mt-4">
            3.신규 비밀번호 생성
        </div>

        <hr>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0 text-right">
                비밀번호
            </label>
            <div class="col-md-9 position-relative">
                <input type="password" class="form-control form-control-sm"
                    formControlName="userPw"
                    [ngClass]="{'is-invalid':submittedNewPw && fNewPw.userPw.errors}">
                <div class="invalid-tooltip" *ngIf="submittedNewPw && fNewPw.userPw.errors">
                    <div *ngIf="fNewPw.userPw.errors.required">필수 입력 항목 입니다</div>
                </div>
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0 text-right">
                비밀번호 확인
            </label>
            <div class="col-md-9 position-relative">
                <input type="password" class="form-control form-control-sm"
                    formControlName="userPw2"
                    [ngClass]="{'is-invalid':submittedNewPw && fNewPw.userPw2.errors}">
                <div class="invalid-tooltip" *ngIf="submittedNewPw && fNewPw.userPw2.errors">
                    <div *ngIf="fNewPw.userPw2.errors.required">필수 입력 항목 입니다</div>
                    <div *ngIf="fNewPw.userPw2.errors.mismatch">비밀번호가 일치하지 않습니다</div>
                </div>
            </div>
        </div>

        <div class="form-group row align-items-center mb-0">
            <div class="col-md-3 mb-0 text-right"></div>
            <div class="col-md-9 position-relative">
                <button type="submit" class="btn btn-sm btn-secondary">
                    재설정
                </button>

                <div class="text-danger mt-2" [hidden]="!newPwFailMessage">
                    <i class="mdi mdi-alert-outline"></i>
                    <span class="ml-1" [innerHtml]="newPwFailMessage"></span>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm"
        ngbAutofocus
        (click)="clickCancel()">
        <i class="far fa-times-circle fa-fw"></i>
        닫기
    </button>
</div>